import React, { lazy } from "react";
import { Route, Routes } from "react-router-dom";
import Page404 from "../pages/Page404";
import { pageMenu } from "./menu";

const MAIN_PAGES = {
  HOME_PAGE: lazy(() => import("../pages/HomePage")),
  PORTFOLIO_PAGE: lazy(() => import("../pages/PorfolioPage")),
  ABOUT_PAGE: lazy(() => import("../pages/AboutPage")),
  CONTACT_PAGE: lazy(() => import("../pages/ContactPage")),
  BLOG_PAGE: lazy(() => import("../pages/BlogPage")),
};

const pages = [
  {
    path: pageMenu.homePage.path,
    element: <MAIN_PAGES.HOME_PAGE />,
    exact: true,
  },
  {
    path: pageMenu.portfolioPage.path,
    element: <MAIN_PAGES.PORTFOLIO_PAGE />,
    exact: true,
  },
  {
    path: pageMenu.aboutPage.path,
    element: <MAIN_PAGES.ABOUT_PAGE />,
    exact: true,
  },
  {
    path: pageMenu.contactPage.path,
    element: <MAIN_PAGES.CONTACT_PAGE />,
    exact: true,
  },
  // {
  //   path: pageMenu.blogPage.path,
  //   element: <MAIN_PAGES.BLOG_PAGE />,
  //   exact: true,
  // },
];

const contents = [...pages];

const ContentRoutes = () => {
  return (
    <Routes>
      {contents.map((page) => (
        <Route key={page.path} {...page} />
      ))}
      <Route path="*" element={<Page404 />} />
    </Routes>
  );
};

export default ContentRoutes;
